import { MapLinkServices, mapLinkUrl } from '@ngsos/portal-core/agency';

import type { GeoPoint } from '@/signalr';

export type ExternalMapLinkModel = {
  iconPath: string;
  altText: string;
  link: string;
};

export type ExternalMapLinkTexts = {
  mapyCzAltText: string;
  googleMapsAltText: string;
};

export function createMapLinkModel(
  service: MapLinkServices,
  coordinates: GeoPoint,
  texts: ExternalMapLinkTexts,
): ExternalMapLinkModel {
  const link = mapLinkUrl(service, coordinates);

  switch (service) {
    case MapLinkServices.MapyCz:
      return { iconPath: 'Images/Icons/icon-mapy.svg', altText: texts.mapyCzAltText, link };
    case MapLinkServices.GoogleMaps:
      return { iconPath: 'Images/Icons/icon-maps.svg', altText: texts.googleMapsAltText, link };
    case MapLinkServices.AirNavPro:
      return { iconPath: 'Images/Icons/icon-air-nav-pro.jpeg', altText: 'Air Navigation Pro', link };
    default:
      throw new Error(`MapLinkServices ${String(service)} is not supported!`);
  }
}
